module.exports = __webpack_public_path__ + "static/media/wifi.2ac75a4c.svg";